import "./Company.css";
import "./CompanyResponsive.css";

import Banner from "../../../shared/banner/Banner";
import arialview from "../../../assets/images/about/arialview.png";
import graduation from "../../../assets/images/about/Graduation.jpg";
import butternut from "../../../assets/images/about/Butternut.jpg";
import CoreValuesAccordion from "../../../widgets/core-values-accordion/CoreValuesAccordion";
import AchievementCard from "../../../widgets/achievements-card/AchievementCard";
import achievementsData from "../../../assets/data/achievements/achievements.json";

function Company() {
  return (
    <>
      <Banner>
        <span>ABOUT US</span>
        <span>/</span>
        <span>COMPANY</span>
      </Banner>

      <div className="row m-0 mt-5 about-us-overview">
        <div className="col-md-6 col-12">
          <img
            src={arialview}
            alt="Farm Overview"
            onContextMenu={(e) => e.preventDefault()}
          />
        </div>
        <div className="col-md-6 col-12">
          <div className="about-us-content-wrapper">
            <div className="d-block">
              <h2>OUR STORY</h2>
              <div className="about-header-border"></div>
              <p>
                <b>Standout Fresh Produce</b> was born from a passion for
                sustainability and a need for self-reliance. Founder Brian Ndou,
                originally in the energy efficiency sector, pivoted to
                agriculture in pursuit of meaningful, long-term impact. Starting
                with agro-processing essential oils and facing the challenge of
                not owning land, the vision grew—driven by the desire to farm
                sustainably and at scale.
              </p>
            </div>
            <div className="d-block">
              <h2>CULTIVATED WITH CARE</h2>
              <div className="about-header-border"></div>
              <p>
                We cultivate a variety of fresh, nutritious vegetables including
                spinach, beetroot, carrots, tomatoes, and more. Each crop is
                grown with care using sustainable practices, and many are
                prepared for modern lifestyles with ready-to-use processing.
                From planting to harvest, and even packaging, our focus is on
                delivering high-quality, healthy produce to families, retailers,
                and communities who value freshness and convenience.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="row m-0 about-vision-mission">
        <div className="col-md-6 col-12">
          <div className="about-us-content-wrapper">
            <div className="d-block">
              <h2>OUR VISION</h2>
              <div className="about-header-border"></div>
              <p>
                To be the leading provider of affordable, fresh, and nutritious
                vegetables and herbs in South Africa, recognized for our
                commitment to quality, health, and sustainability
              </p>
            </div>
            <div className="d-block">
              <h2>OUR MISSION</h2>
              <div className="about-header-border"></div>
              <p>
                To be the leading provider of affordable, fresh, and nutritious
                vegetables and herbs in South Africa, recognized for our
                commitment to quality, health, and sustainability
              </p>
            </div>
          </div>
        </div>
        <div className="col-md-6 col-12">
          <img
            src={graduation}
            alt="Standout Graduation Day"
            onContextMenu={(e) => e.preventDefault()}
          />
        </div>
      </div>

      <div className="row m-0 about-core-values">
        <div className="col-12">
          <h1>OUR CORE VALUES</h1>
        </div>
        <div className="col-md-6 col-12">
          <img src={butternut} alt="Standout Core Values" onContextMenu={(e) => e.preventDefault()}/>
        </div>
        <div className="col-md-6 col-12">
          <div className="about-us-content-wrapper">
            <CoreValuesAccordion />
          </div>
        </div>
      </div>

      <div className="row m-0 about-journey-so-far">
        <div className="col-12">
          <h1>OUR JOURNEY SO FAR</h1>
        </div>
        <div className="col-12 row align-items-stretch m-0 about-us-achievemts">
          {achievementsData.map((item, index) => {
            return (
              <div className="col-sm-6 col-12 about-us-achievement-card" key={index}>
                <AchievementCard data={item} />
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
}

export default Company;
